import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PartneriService {
  constructor(private _http: HttpClient) {}

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_partnere', a)
      .pipe(map((res: any) => res));
  }

  partnerUredi(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'partner_uredi', a)
      .pipe(map((res: any) => res));
  }

  dohvatiGrupePartnera(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_partnergrupe', a)
      .pipe(map((res: any) => res));
  }
}
